import Styled from "styled-components";
import { respondTo } from "@/respondTo";

export const SignUpContainer = Styled.div`
position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* height: 100%; */
    max-width: 1512px;
    padding: 2.5rem 1.25rem;
    background-color: var(--background-light);
    gap: 1.25rem;
    height: 100%;

    ${respondTo.tablet_landscape_s`
    flex-direction: row; 
    padding: 2.5rem 2.5rem
    `}

    ${respondTo.desktop`
    flex-direction: row; 
    padding: 2.5rem 2.5rem
    `}

    ${respondTo.desktop_xl`
    padding: 2.5rem 4.375rem
    `}
     
    `;

export const ImgContainer = Styled.div`
position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 26.125rem;
    background-color: var(--on-primary-dark);
    border-radius: 0.625rem;
    gap : 1.25rem;
    padding: 1.25rem;

    ${respondTo.tablet_landscape_s`
           order: 1;
           height:40.93rem;
           padding: 2.5rem 1.25rem;
           align-items: center ;
           justify-content: space-between;
           gap : 2.5rem;
           border-radius: 0;
    `}

    ${respondTo.desktop`	
     order: 1;
     height:54.93rem;
     padding: 2.5rem 1.25rem;
     align-items: center ;
     justify-content: space-between;
     gap : 2.5rem;
     border-radius: 0;
    `}
    `;

export const HeroContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap : 1.25rem;
    color : var(--on-surface-dark);

    ${respondTo.tablet_landscape_s`
    align-self: flex-start;
    `}

    ${respondTo.desktop`
    gap : 2.5rem;

    `}
    `;

export const HeroImg = Styled.img`
    width: auto;
    height: 130px;
    padding: 1.25rem 0 0;

    ${respondTo.tablet_landscape_s`
    width: auto;
    height: 200px;
    padding: 1.25rem 0 0;
    `}

    ${respondTo.desktop`
    width: auto;
    height: auto;
    max-width: 21.25rem;
    max-height: 21.25rem;
    padding: 0;
    `}
    `;

export const HeroInfo = Styled.div`
 ${respondTo.desktop`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    `}
    `;

export const ArrowBox = Styled.div`
    display: flex;
    color: var(--on-surface-dark);
    `;

export const FormContainer = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap : 1.25rem;
   
    `;

export const InfoBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap : 1.25rem;
    

    h1 {
        color: var(--on-background-light);
    }

    p {
        color: var(--on-primary-container-light);
    }

    ${respondTo.desktop`
    `}
    `;

export const FormBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap : 1.25rem;
    height: 100%;
    padding: 0 0 0.625rem;

    ${respondTo.desktop`
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap : 1.25rem;
    height: 100%;
    width: 100%;
    padding: 2.5rem 0 1.25rem;
    `}
`;
export const FooterBox = Styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap : 1.25rem;
    padding-top: 1.25rem;

    ${respondTo.desktop`
    align-items: flex-start;
     gap : 0;
    `}

    `;

export const CheckboxContainer = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    align-self: flex-start;
    padding-bottom: 1.875rem;

    ${respondTo.desktop`
    padding-bottom: 1rem;
    `}
    `;

export const BtnContainer = Styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 1.25rem;

${respondTo.tablet_landscape_s`
align-items: flex-start;
`}

${respondTo.desktop`
padding: 1.25rem 0 0 1.25rem;
`}
`;

export const sxBtn = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.625rem",

  "@media (min-width: 1024px)": {
    alignItems: "flex-start",
  },

  "@media (min-width: 1512px)": {
    gap: "1.25rem",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
};

export const formWidth = {
  width: "100%",

  "@media (min-width: 1194px)": {
    width: "48%",
  },
};

export const TableContainer = Styled.div`
    display: flex;
    align-items: flex-start;
    height: 100%;
    width: 100%;
    align-self: flex-start;
    background-color: var(--on-surface-dark);
    ${respondTo.tablet_landscape_s`
    order: 1;

    `}
    `;

export const TableBox = Styled.div`
   display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    `;

export const Header = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.25rem;
    width: 100%;
    justify-content: space-between;
    background-color: var(--on-primary-dark);
    `;

export const DataCard = Styled.div`
    display: flex;
    color:  var(--on-surface-dark);
    gap: 1px;
    align-items: center;
    justify-content: flex-start;


    h1 {
        width: 50%;
    }
    p {
        width: 50%;
    }

    ${respondTo.desktop`
        gap: 0.625rem;
        p {
            width: 30%;
        }
    `}
    `;

export const TableRow = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 1.25rem;
    width: 100%;
    background-color: var(--surface-95-light);
    gap:  1.25rem;

    ${respondTo.tablet_landscape_s`
       height: 100%;
    `}
  
    `;

export const RowDescription = Styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.625rem;
    width: 75%;

    img {
        width:auto;
        height: 30px;
    }

    ${respondTo.tablet_landscape_s`
      img {
        width: auto;
        height: 35px;
    }
    `}
    `;

export const RowTilde = Styled.div`
    width: 25%;

    img {
        width: 24px;
        height: 24px;
    }
    `;
